import { useState } from 'react';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { H4 } from 'foundations-components/transitional/components/H4';
import { H7 } from 'foundations-components/transitional/components/H7';
import { HR } from 'foundations-components/transitional/components/HR';
import { Button } from 'foundations-components/transitional/components/Button';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { useBreakpoint } from '../hooks/useBreakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PANEL_WIDTH_BY_BREAKPOINT = {
  phone: '100%',
  tablet: '80%',
  desktop: 600
};
export function PasswordResetPanel({
  onClose
}) {
  const breakpoint = useBreakpoint();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  return /*#__PURE__*/_jsxs(Panel, {
    width: PANEL_WIDTH_BY_BREAKPOINT[breakpoint],
    children: [/*#__PURE__*/_jsx(CloseButton, {
      onClick: onClose,
      color: "text-core-default"
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsxs(PanelSection, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "unstyled",
          onClick: onClose,
          paddingInline: "0",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "100",
            children: [/*#__PURE__*/_jsx(LeftIcon, {
              size: "100",
              color: "text-core-default"
            }), /*#__PURE__*/_jsx(Paragraph, {
              color: "text-core-default",
              marginBlock: "0",
              typography: "body-100",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.myAccountPopover.settings.security.back"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(H4, {
          color: "text-core-default",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.myAccountPopover.settings.security.changePasswordHeading"
          })
        }), /*#__PURE__*/_jsx(H7, {
          color: "text-core-default",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.myAccountPopover.settings.security.changePasswordSubtitle"
          })
        }), /*#__PURE__*/_jsx(HR, {
          distance: "flush"
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          marginBlockStart: "300",
          children: [/*#__PURE__*/_jsx(View, {
            marginBlockEnd: "300",
            children: /*#__PURE__*/_jsx(Fieldset, {
              _size: "small",
              children: /*#__PURE__*/_jsx(FormControl, {
                label: unescapedText('app.myAccountPopover.settings.security.currentPasswordLabel'),
                children: /*#__PURE__*/_jsx(TextInput, {
                  type: "password",
                  name: "currentPassword",
                  value: currentPassword,
                  onChange: event => setCurrentPassword(event.target.value),
                  typography: "body-100"
                })
              })
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlockEnd: "300",
            children: /*#__PURE__*/_jsx(Fieldset, {
              _size: "small",
              children: /*#__PURE__*/_jsx(FormControl, {
                label: unescapedText('app.myAccountPopover.settings.security.newPasswordLabel'),
                children: /*#__PURE__*/_jsx(TextInput, {
                  type: "password",
                  name: "newPassword",
                  value: newPassword,
                  onChange: event => setNewPassword(event.target.value),
                  typography: "body-100"
                })
              })
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlockEnd: "300",
            children: /*#__PURE__*/_jsx(Fieldset, {
              _size: "small",
              children: /*#__PURE__*/_jsx(FormControl, {
                label: unescapedText('app.myAccountPopover.settings.security.confirmPasswordLabel'),
                children: /*#__PURE__*/_jsx(TextInput, {
                  type: "password",
                  name: "confirmPassword",
                  value: confirmPassword,
                  onChange: event => setConfirmPassword(event.target.value),
                  typography: "body-100"
                })
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          justifyContent: "end",
          gap: "200",
          marginBlockStart: "300",
          children: [/*#__PURE__*/_jsx(Button, {
            use: "secondary-ghost",
            onClick: onClose,
            children: /*#__PURE__*/_jsx(Paragraph, {
              color: "text-core-default",
              marginBlock: "0",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.myAccountPopover.settings.security.cancel"
              })
            })
          }), /*#__PURE__*/_jsx(Button, {
            use: "primary",
            children: /*#__PURE__*/_jsx(Paragraph, {
              color: "text-core-default",
              marginBlock: "0",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.myAccountPopover.settings.security.updatePassword"
              })
            })
          })]
        })]
      })
    })]
  });
}